"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
function FolderCheckedIcon(_a) {
    var { fill = 'white' } = _a, props = __rest(_a, ["fill"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "20", height: "18", viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("path", { fill: fill, fillRule: "evenodd", clipRule: "evenodd", d: "M20 16C20 17.1046 19.1046 18 18 18H2C1.46957 18 0.960861 17.7893 0.585789 17.4142C0.210716 17.0391 1.95372e-06 16.5304 1.90735e-06 16L3.33387e-06 10.5L0 2C0 0.895431 0.895432 0 2 0H8.5C9.25755 0 9.95007 0.428004 10.2889 1.10557L11.2361 3L11.5 3L18 3C19.1046 3 20 3.89543 20 5L20 16ZM9 3L8.5 2L4 2L2 2V3H9ZM2 5L2 10.5L2 14L2 16H4L16 16H18V14V7L18 5H16H11.5L10.618 5L2 5ZM13.0892 7.69199C13.5354 8.01738 13.6334 8.64292 13.308 9.08917L10.3913 13.0892C10.2072 13.3417 9.9156 13.4936 9.60314 13.4998C9.29067 13.506 8.99328 13.3657 8.79929 13.1207L7.21596 11.1207C6.87315 10.6877 6.94628 10.0588 7.3793 9.71595C7.81231 9.37315 8.44124 9.44628 8.78405 9.8793L9.55061 10.8476L11.692 7.91083C12.0174 7.46458 12.6429 7.3666 13.0892 7.69199Z" })));
}
exports.default = FolderCheckedIcon;
